import React from 'react';


const HoroscopeMatchingReport = ({ data }) => {
  if (!data) return null;

  
  //console.log('HoroscopeMatchingReport received data:', data);

  // Handle different possible data structures
  let girl, boy, guna_milan, astrological_message;
  
  // Check if data has girl_info/boy_info structure (from API response)
  if (data.girl_info && data.boy_info) {
    girl = data.girl_info;
    boy = data.boy_info;
    guna_milan = data.guna_milan;
    astrological_message = data.message;
  } 
  // Check if data has direct girl/boy structure
  else if (data.girl && data.boy) {
    girl = data.girl;
    boy = data.boy;
    guna_milan = data.guna_milan;
    astrological_message = data.astrological_message || data.message;
  }
  // Fallback to original structure
  else {
    girl = data.girl;
    boy = data.boy;
    guna_milan = data.guna_milan;
    astrological_message = data.astrological_message;
  }

  // Helper function to render person details card
  const renderPersonCard = (personData, title, emoji, bgColor) => {
    if (!personData) {
      return (
        <div className={`bg-white rounded-lg p-6 border shadow-sm ${bgColor}`}>
          <h3 className="text-lg font-semibold mb-4 text-gray-800">
            {emoji} {title}
          </h3>
          <p className="text-red-500">Data not available</p>
        </div>
      );
    }

    return (
      <div className={`bg-white rounded-lg p-6 border shadow-sm ${bgColor}`}>
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          {emoji} {title}
        </h3>
        
        {/* Nakshatra */}
        <div className="mb-3">
          <p className="text-sm text-gray-700">
            <span className="font-medium">Nakshatra:</span> {personData.nakshatra?.name || 'N/A'} (Pada {personData.nakshatra?.pada || 'N/A'})
          </p>
        </div>

        {/* Rashi */}
        <div className="mb-4">
          <p className="text-sm text-gray-700">
            <span className="font-medium">Rasi:</span> {personData.rasi?.name || 'N/A'} – Lord: {personData.rasi?.lord?.name || personData.rasi?.lord || 'N/A'}
          </p>
        </div>

        {/* Koot Details */}
        {(personData.koot || personData.hoot) && (
          <div>
            <h4 className="text-sm font-semibold mb-2 text-gray-800">Koot Details:</h4>
            <div className="space-y-1">
              {Object.entries(personData.koot || personData.hoot).map(([key, value]) => (
                <div key={key} className="flex justify-between items-center text-sm">
                  <span className="text-gray-600 capitalize">
                    {key.replace(/_/g, ' ')}:
                  </span>
                  <span className="font-medium text-gray-800">{value || 'N/A'}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Helper function to render score card
  const renderScoreCard = () => {
    // Handle different possible property names for guna milan
    const obtainedPoints = guna_milan?.obtained_points || guna_milan?.total_points || 0;
    const totalPoints = guna_milan?.total_points || guna_milan?.maximum_points || 0;
    
    return (
      <div className="bg-white rounded-lg p-6 border shadow-sm">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          🔢 Guna Milan (Score)
        </h3>
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600 mb-2">
            {obtainedPoints} / {totalPoints}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
            <div
              className="bg-green-500 h-2 rounded-full transition-all duration-1000"
              style={{
                width: `${totalPoints ? (obtainedPoints / totalPoints) * 100 : 0}%`
              }}
            ></div>
          </div>
          <p className="text-sm text-gray-600">
            {totalPoints ? Math.round((obtainedPoints / totalPoints) * 100) : 0}% Compatibility
          </p>
        </div>
      </div>
    );
  };

  // Helper function to render message card
  const renderMessageCard = () => {
    if (!astrological_message) return null;

    return (
      <div className="bg-white rounded-lg p-6 border shadow-sm">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          ⚠️ Astrological Message
        </h3>
        <div className="text-sm text-gray-700 leading-relaxed">
          <p>{astrological_message.description || astrological_message.message || 'No astrological message available.'}</p>
        </div>
      </div>
    );
  };

  // Show error if no valid data found
  if (!girl && !boy) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-white rounded-lg p-6 border shadow-sm">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Horoscope Matching Report</h1>
            <div className="text-center text-red-500">
              <p>No valid data found in the response.</p>
              <p className="text-sm mt-2">Available keys: {Object.keys(data).join(', ')}</p>
              <details className="mt-4 text-left">
                <summary className="cursor-pointer text-blue-600">Show raw data</summary>
                <pre className="mt-2 p-4 bg-gray-100 rounded text-xs overflow-auto">
                  {JSON.stringify(data, null, 2)}
                </pre>
              </details>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Horoscope Matching Report
          </h1>
        </div>

        {/* Grid Layout - 3 columns on desktop, responsive on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {/* Girl's Details Card */}
          {renderPersonCard(
            girl,
            "Girl's Details",
            "👩",
            ""
          )}

          {/* Boy's Details Card */}
          {renderPersonCard(
            boy,
            "Boy's Details", 
            "👨",
            ""
          )}

          {/* Guna Milan Score Card */}
          {renderScoreCard()}

          {/* Astrological Message Card - spans full width */}
          <div className="md:col-span-2 lg:col-span-3">
            {renderMessageCard()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoroscopeMatchingReport;